import React from "react";
import { Box, Grid } from "@mui/material";
import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

const SalfordCaseStudy = () => {
  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (Salford)`,
      link: `/why/case-study/Salford`,
    },
  ];

  return (
    <Box>
      <Grid>
        <title>Salford - Case Study | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={"Client Case Study - Education"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc="/images/SalfordLogo-horizontal.png"
                title="Client Profile-Education Sector"
                objectFit="contain"
                subTitle="Industry-Focused University Concentrating on Labour Market Skills"
                //example to link in text
                body={`Salford University - located 1 mile from Manchester City Centre - is a truly global institution that serves the needs
                 of industry, commerce and education. Salford's university community encompasses over 23,000 students, 2500 staff and 170,000 
                 alumni who come to study, teach and research here from all around the world. Its thriving <i>industry-focused research</i>is 
                 cutting edge, rising to the challenges and opportunities of the fourth industrial revolution. <br><br>
                 As "thinking machines" continue  to replace human tasks and jobs, and smart cities become a reality, the focus for the next few years is to strengthen its position
                  specifically in robotics, digital and smart living. Salford already have a solid base on which to build from, as these three areas 
                  cut across everything that they already do. Everything Salford does works alongside industry in innovative ways to meet the needs of the  environment and workforce of the future. `}
              />
              {/* Whether it be: research into "gentle" robots that can handle delicate items on a production line, working with industry to deliver our leading prosthetics work that helps patients recover their movement more quickly, or students learning about systems that will safely carry people from A to B in autonomous vehicles; */}
              {/* <CustomizedAccordions
                title="Types of Global Risk"
                body={`<ul>
                <li>Macroeconomic - Consumer Demand, Fiscal Tax/Spend, Inflation, Currency</li>
                <li>Supply/Geopolitical- supply disruptions </li>
                <li>Energy - technology breakthroughs and tech-diffusuion</li>
                <li>Carbon Transition - green taxation, technology shocks</li>
                <li>Climate/Physical - flooding, heatwaves, desertification</li>
                </ul>`}
              /> */}
              {/* <CustomizedAccordions
                title="How MEF can help - CASE STUDY"
                body={`We assist many different types of firm deal with the anticipation & quantification of Global risk that will likley impact their domain-level operations.
                One such firm is Decision Analysis Services Ltd which MEF have been working with for almost 25 years <a href='/case-study/DAS'> DAS Case Study</a>`}
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc="/images/MacroMapsMenuf1a.jpg"
                title="Client Needs-Embedding Applied Apps"
                objectFit="fill"
                subTitle={`Why Salford work with MEF - risk2NZ App in the Classroom`}
                body={`As an industry-focused research University, Salford's teaching offer also looks to be informed by practitoners in the field. After collaborating on the University's AI Foundry program,
                MEF deepened its links with the University. Applying AI to its risk2NZ mobile App allows MEF to automate some of the student guidance/nudging that can normally
                happen only in the classroom. Using such intelligent AI bots, thus enable course Unit leaders at Salford to devote more time to course material development & targeted, pastoral interventions with students`}
              />
              <CustomizedAccordions
                title="risk2NZ App in the MBA classroom"
                body={`[How risk2NZ was incorporated into existing MBA curriculuum]`}
              />
              {/* <CustomizedAccordions
                title="MEF Standard scenarios2"
                body="Fund Managers can then explore/qunatify potential fund risk from key national/global macro & environmental/Esg risks & threats via the Portfolio interrogation form."
              /> */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc="/images/FeedbackFaces_Original.jpg"
                objectFit="contain"
                title="Client Feedback"
                subTitle={`On MEF collaboration & how risk2NZ enhances the curriculuum`}
                body={`<i>"..as an industry-focused University ...."</i><br><br>
                <hr style="color:#00a0a0;height:1px;width:50%;">
                If you would like to initiate an informal chat about how MEF's models/tools/Apps may augment your educational/teaching or CPD offer, please email us
                at: <b style="color:#00a0a0" > education@mef-uk.com </b> `}
              />
              {/* <CustomizedAccordions
                title="Emissions Analysis1"
                body="iGEM allows the feed-through of mGEM global/national shocks to 12 industrial sectors (ISIC Rev. 4) across most/all of the major economies covered by mGEM."
              />
              <CustomizedAccordions
                title="Emissions Analysis2"
                body="SME managers can (cost-effectively) explore potential trading risk & opportunities in key global/national industry sectors. MEF can also construct SME-specific weighted indices of overall export prospects across all the SME's key export markets. mGEM shocks at a global/national level can then be translated into market-specific impacts for tailored SME risk analysis."
              /> */}
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default SalfordCaseStudy;
